import { useEffect, useRef, useState } from 'react';
import { useFetchServices } from './use-fetch-services';

export const useFetchLicenses = () => {
  const [licenses, setLicenses] = useState([]);
  const isMounted = useRef(true);

  const { services, loading } = useFetchServices();

  useEffect(() => {
    isMounted.current = true;
    if (services.length > 0) {
      const licenses = services.filter(s => Number(s.cdServico) >= 16 && Number(s.cdServico) < 23);
      if (isMounted.current) setLicenses(licenses);
    }

    return () => {
      isMounted.current = false;
    };
  }, [services]);

  return {
    loading,

    licenses,
  };
};